import { createStore } from 'effector'
import { register } from '~/core/repository'

export const VodCardHorizontalCoversMap = {
  Cover1: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_1.webp',
  Cover2: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_2.webp',
  Cover3: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_3.webp',
  Cover4: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_4.webp',
  Cover5: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_5.webp',
  Cover6: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_6.webp',
  Cover7: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_7.webp',
  Cover8: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_8.webp',
  Cover9: '/img/vodcardcovers/horizontal/vodcardcoverhorizontal_9.webp',
}

export const $vodCardHorizontalCovers = createStore(VodCardHorizontalCoversMap)

register(
  $vodCardHorizontalCovers,
  '$shared/ui/cardCovers/vodCardHorizontalCovers'
)

export const VodCardVerticalCoversMap = {
  Cover1: '/img/vodcardcovers/vertical/vodcardcoversvertical_1.webp',
  Cover2: '/img/vodcardcovers/vertical/vodcardcoversvertical_2.webp',
  Cover3: '/img/vodcardcovers/vertical/vodcardcoversvertical_3.webp',
  Cover4: '/img/vodcardcovers/vertical/vodcardcoversvertical_4.webp',
  Cover5: '/img/vodcardcovers/vertical/vodcardcoversvertical_5.webp',
  Cover6: '/img/vodcardcovers/vertical/vodcardcoversvertical_6.webp',
  Cover7: '/img/vodcardcovers/vertical/vodcardcoversvertical_7.webp',
  Cover8: '/img/vodcardcovers/vertical/vodcardcoversvertical_8.webp',
  Cover9: '/img/vodcardcovers/vertical/vodcardcoversvertical_9.webp',
}

export const $vodCardVerticalCovers = createStore(VodCardVerticalCoversMap)

register($vodCardVerticalCovers, '$shared/ui/cardCovers/vodCardVerticalCovers')
